<div
  class="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-neutral-50 to-slate-100 relative overflow-hidden font-sans"
>
  <div
    class="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:24px_24px]"
  ></div>

  <div
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-neutral-900/[0.02] rounded-full blur-3xl pointer-events-none"
  ></div>

  <div
    class="w-full max-w-[440px] bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100/80 p-6 relative z-10 mx-2"
  >
    <div class="text-center mb-4">
      <div class="flex justify-center mb-4">
        <img src="/login.png" alt="SMV Logo" class="h-26 w-auto object-contain" />
      </div>
      <h1 class="text-2xl font-bold text-slate-900 tracking-tight">Bem-vindo de volta</h1>
      <p class="text-xs text-slate-400 mt-1.5">Acesse sua conta para continuar</p>
    </div>

    <div
      *ngIf="errorMessage()"
      class="mb-6 p-3 bg-red-50/80 border border-red-200 rounded-lg animate-fadeIn"
    >
      <div class="flex items-center gap-2">
        <div class="w-1.5 h-1.5 rounded-full bg-red-500"></div>
        <p class="text-xs font-medium text-red-600">{{ errorMessage() }}</p>
      </div>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-5">
      <div>
        <label class="block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-2">
          Email
        </label>
        <div class="relative">
          <input
            type="email"
            formControlName="email"
            placeholder="exemplo@email.com ou 84XXXXXXX"
            class="w-full px-3.5 py-2.5 bg-white border border-slate-200 rounded text-sm text-slate-800 placeholder-slate-400 focus:border-neutral-900 focus:outline-none transition-colors duration-200"
            [class.border-red-400]="
              loginForm.get('email')?.invalid && loginForm.get('email')?.touched
            "
          />
        </div>
        <div
          *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
          class="mt-1"
        >
          <p class="text-[11px] text-red-500">Por favor, insira um identificador válido.</p>
        </div>
      </div>

      <div>
        <div class="flex items-center justify-between mb-2">
          <label class="text-xs font-semibold text-slate-700 uppercase tracking-wider">
            Senha
          </label>
          <!-- <button
            type="button"
            (click)="forgotPassword()"
            class="text-xs font-medium text-yellow-600 hover:text-yellow-700 hover:underline bg-transparent border-none p-0 transition-colors"
          >
            Esqueceu a senha?
          </button> -->
        </div>

        <div class="relative">
          <input
            [type]="showPassword() ? 'text' : 'password'"
            formControlName="password"
            placeholder="Digite sua senha"
            class="w-full pl-3.5 pr-10 py-2.5 bg-white border border-slate-200 rounded text-sm text-slate-800 placeholder-slate-400 focus:border-neutral-900 focus:outline-none transition-colors duration-200"
            [class.border-red-400]="
              loginForm.get('password')?.invalid && loginForm.get('password')?.touched
            "
          />
          <button
            type="button"
            (click)="togglePassword()"
            class="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
          >
            <svg
              *ngIf="!showPassword()"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
            <svg
              *ngIf="showPassword()"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
              />
            </svg>
          </button>
        </div>
        <div
          *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          class="mt-1"
        >
          <p class="text-[11px] text-red-500">A senha é obrigatória.</p>
        </div>
      </div>

      <div class="flex items-center">
        <input
          id="remember_me"
          type="checkbox"
          class="w-4 h-4 text-neutral-900 border-slate-300 rounded focus:ring-neutral-900 focus:ring-1"
        />
        <label for="remember_me" class="ml-2 text-xs text-slate-500 cursor-pointer select-none"
          >Lembrar-me neste dispositivo</label
        >
      </div>

      <button
        type="submit"
        [disabled]="loginForm.invalid || isLoading()"
        class="w-full py-2.5 bg-neutral-900 text-white rounded text-sm font-medium hover:bg-neutral-800 active:bg-neutral-950 transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed shadow-sm"
      >
        <div class="flex items-center justify-center gap-2">
          <span *ngIf="!isLoading()">Entrar</span>
          <div
            *ngIf="isLoading()"
            class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
          ></div>
          <span *ngIf="isLoading()">Processando...</span>
        </div>
      </button>
    </form>

    <div class="text-center mt-8 pt-4 border-t border-slate-100">
      <p class="text-[10px] font-medium text-slate-400 uppercase tracking-widest">
        ENTRETECH - SMV
      </p>
    </div>
  </div>
</div>
